import React, {PureComponent} from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import {Link} from "react-router-dom";
import {UserContext} from "../../core/UserContext";
import Button from "@mui/material/Button";
import {UrlBuilder} from "../../core/url/UrlBuilder";
import withStyles from '@mui/styles/withStyles';
import {PageDataContext} from "../../core/PageDataContext";
import ActiveWorkoutButton from "./utils/ActiveWorkoutButton";
import Tooltip from "@mui/material/Tooltip";

import SettingsIcon from '@mui/icons-material/Settings';
import Badge from "@mui/material/Badge";
import {withRouter} from "../../hooks/withRouter";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

const useStyles = theme => ({
	grow: {
		flexGrow: 1,
	},
	sectionDesktop: {
		display: 'none',
		[theme.breakpoints.up('md')]: {
			display: 'flex',
			alignItems: 'center',
			gap: theme.spacing(0.5),
		},
	},
	sectionMobile: {
		[theme.breakpoints.up('md')]: {
			display: 'none',
		},
	},
	navButton: {
		borderRadius: 8,
		minWidth: 'unset',
		padding: '4px 14px',
		fontWeight: 500,
		fontSize: '0.85rem',
		letterSpacing: '0.02em',
		textTransform: 'none',
		color: 'rgba(255, 255, 255, 0.6)',
		transition: 'background-color 0.15s, color 0.15s',
		'&:hover': {
			backgroundColor: 'rgba(255, 255, 255, 0.08)',
			color: '#fff',
		},
	},
	navButtonActive: {
		backgroundColor: 'rgba(255, 255, 255, 0.12)',
		color: '#fff',
		'&:hover': {
			backgroundColor: 'rgba(255, 255, 255, 0.18)',
		},
	},
	title: {
		fontWeight: 600,
		fontSize: '1.05rem',
		letterSpacing: '0.01em',
	},
});

class TopNavMenu extends PureComponent {
	static displayName = TopNavMenu.name;

	goToSettingsPage = () => {
		this.props.navigate(UrlBuilder.user.settingsPage());
	};

	goToAdminPage = () => {
		this.props.navigate(UrlBuilder.admin.overviewPage());
	};

	isActive = (path) => {
		const location = window.location.pathname;
		if (path === '/') return location === '/';
		return location.startsWith(path);
	};

	navButtonClass = (path) => {
		const { classes } = this.props;
		return `${classes.navButton} ${this.isActive(path) ? classes.navButtonActive : ''}`;
	};

	render() {
		const { classes } = this.props;

		return (
            <AppBar position={"sticky"} enableColorOnDark elevation={0}>
				<Toolbar variant={"dense"}>
					<PageDataContext.Consumer>
						{({data}) =>
							<Typography variant="h6" noWrap className={classes.title}>
								<UserContext.Consumer>
									{({user}) => data.title ?? (user?.name ? (user.name + "’s Work in Progress") : "My Work in Progress")
									}
								</UserContext.Consumer>
							</Typography>
						}
					</PageDataContext.Consumer>

					<div className={classes.grow}/>

					<UserContext.Consumer>
						{({user}) => user ?
							<React.Fragment>
								<span className={classes.sectionDesktop}>
									<Button component={Link} to={'/'} className={this.navButtonClass('/')}>Home</Button>
									<Button component={Link} to={UrlBuilder.routine.routineOverviewPage()} className={this.navButtonClass(UrlBuilder.routine.routineOverviewPage())}>Routines</Button>
									<Button component={Link} to={UrlBuilder.exercise.exercisesOverviewPage()} className={this.navButtonClass(UrlBuilder.exercise.exercisesOverviewPage())}>Exercises</Button>
									<Button component={Link} to={UrlBuilder.me.mePage()} className={this.navButtonClass(UrlBuilder.me.mePage())}>Me</Button>
								</span>

								<ActiveWorkoutButton/>

								{user.email === 'henryhs97@gmail.com' &&
									<Tooltip title="Admin">
										<IconButton edge="end" onClick={this.goToAdminPage} color="inherit" size="large">
											<AdminPanelSettingsIcon/>
										</IconButton>
									</Tooltip>
								}

								<Tooltip title="Settings">
									<IconButton edge="end" onClick={this.goToSettingsPage} color="inherit" size="large">
										{user.hasNotifications ?
											<Badge badgeContent={1} color="secondary">
												<SettingsIcon />
											</Badge>
											:
											<SettingsIcon />
										}
									</IconButton>
								</Tooltip>
							</React.Fragment>
							:
							<span className={classes.sectionDesktop}>
								<Button component={Link} to={'/'} className={this.navButtonClass('/')}>Home</Button>
								<Button component={Link} to={UrlBuilder.user.SignInPage()} className={this.navButtonClass(UrlBuilder.user.SignInPage())}>Sign in</Button>
								<Button component={Link} to={UrlBuilder.user.SignUpPage()} className={this.navButtonClass(UrlBuilder.user.SignUpPage())}>Sign up</Button>
							</span>
						}
					</UserContext.Consumer>
				</Toolbar>
			</AppBar>
        );
	}
}

export default withRouter((withStyles(useStyles)(TopNavMenu)))
